import { render, staticRenderFns } from "./BannerImageForm.vue?vue&type=template&id=b97b901c"
import script from "./BannerImageForm.vue?vue&type=script&lang=ts"
export * from "./BannerImageForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports